import type { LaunchOptionPromptDataV2 } from 'owa-bizchat-types/lib/types';

export interface DeeplinkValues
    extends Partial<
        Pick<LaunchOptionPromptDataV2, 'id' | 'scenario' | 'conversationId' | 'chatType'>
    > {
    /* base64-encoded deeplink (from routing) */
    encodedDeeplink: string | undefined;
}

let deeplinkValues: DeeplinkValues | null = null;

export function setDeeplinkValues(values: DeeplinkValues): void {
    deeplinkValues = { ...values };
}

export function resetDeeplinkValues(): void {
    deeplinkValues = null;
}

export function getDeeplinkValues(): DeeplinkValues | null {
    return deeplinkValues;
}
